import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { productShortName } from '../data/offer';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-221" data-mp="21ydbohrq2ixm">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-lg border border-gold/40 border-l-4 border-l-mineral bg-steel p-4 pr-10 text-white shadow-2xl shadow-black/40" aria-live="polite" data-id="element-222" data-mp="1wxxvlig22xby">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-muted transition-colors duration-150 ease-out hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-mineral" aria-label="Dismiss notice" data-id="element-223" data-mp="1sgper49t63hy">
            <XIcon className="h-4 w-4" data-id="element-224" data-mp="19pokgtjmuw4q" />
          </button>
          <div className="flex gap-3" data-id="element-225" data-mp="19o3nyydrd348">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-mineral" aria-hidden="true" data-id="element-226" data-mp="1efv74nul46kc" />
            <div data-id="element-227" data-mp="zrikihhe002i">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-mineral" data-id="element-228" data-mp="zs0d944ubw5o">Access confirmed</p>
              <p className="mt-1 text-sm leading-snug text-muted" data-id="element-229" data-mp="14r3hwngws0d4">
                Once your purchase is complete you receive the
                <br data-id="element-230" data-mp="qsnbkxmykbvi" />
                <span className="font-bold text-white" data-id="element-231" data-mp="vpngv6bzhalk">{productShortName}</span>
              </p>
              <p className="mt-2 text-xs text-muted" data-id="element-232" data-mp="2xet3v9k9b6aq">Instant digital access by email</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}